import React, { ChangeEvent, useEffect, useState } from 'react';
import { MdOutlineDocumentScanner } from 'react-icons/md';
import ContainerFlex from '~/components/containerFlex';
import ButtonSearch from '../buttonSearch';
import { IListCol } from '../listView/row/col';
import { components } from '~/assets';
import * as St from './styles';
import ButtonAction from '~/views/Consult/User/HistoryLoan/components/ActionButton';
import { VscSend, VscTrash } from 'react-icons/vsc';
import { FaDownload } from 'react-icons/fa6';
import Button from '../button';
interface IProps {
  readonly customerHeader: any;
  list: Array<Array<Object>>;
  readonly checkbox?: boolean;
  readonly showSelectAll?: boolean;
  readonly orderBy?: string;
  onSubmitOrder?: Function;
  onSubmitSelectedRows?: Function;
  ordenationField?: string;
  fixedHeader?: boolean;
  disableRowShadow?: boolean;
}

interface ICheckbox {
  id?: number;
  isChecked?: boolean;
  data?: any;
}

const TableList: React.FC<IProps> = ({
  customerHeader,
  list,
  checkbox = false,
  onSubmitOrder,
  orderBy,
  onSubmitSelectedRows,
  ordenationField,
  showSelectAll = false,
  fixedHeader = false,
  disableRowShadow = false,
}) => {
  const [selected, setSelected] = useState<ICheckbox[]>([]);
  const [selectedAll, setSelectedAll] = useState<boolean>(false);
  const [data, setData] = useState([]);
  const [header, setHeader] = useState([]);

  const isSelected = (id: number) => {
    const found = selected.find((item) => item.id === id);
    return !!(found && found.isChecked);
  };
  const handleCheckbox = (e: ChangeEvent<HTMLInputElement>, id: number) => {
    const newChecked = [...selected];

    setSelected(() => {
      newChecked.find((e) => e.id === id).isChecked = e.target.checked;
      return newChecked;
    });
  };
  const handleCheckAll = () => {
    setSelectedAll(!selectedAll);
    setSelected((prev) =>
      prev.map((item) => ({ ...item, isChecked: !selectedAll })),
    );
  };

  const handleSubmitOrder = (column: String) => {
    if (orderBy === 'ASC') {
      onSubmitOrder({
        order: 'DESC',
        column,
      });
    } else {
      onSubmitOrder({
        order: 'ASC',
        column,
      });
    }
  };

  useEffect(() => {
    // construir cópia do header e adicionar/remover coluna de checkbox à esquerda
    const headerCopy = Array.isArray(customerHeader) ? [...customerHeader] : [];
    // remover qualquer coluna de marcador de checkbox que possamos ter adicionado anteriormente
    const existingIndex = headerCopy.findIndex(
      (h) => h && h.isCheckboxColumn === true,
    );
    if (existingIndex !== -1) headerCopy.splice(existingIndex, 1);

    if (checkbox) {
      headerCopy.unshift({
        id: 'checkbox',
        value: '',
        maxChar: 5,
        textAlign: 'center',
        isCheckboxColumn: true,
      });
    }

    setHeader(headerCopy);
  }, [customerHeader, checkbox]);

  useEffect(() => {
    // construir cópia local das linhas e garantir que exista uma célula `id`
    const newData = Array.isArray(list)
      ? list.map((subArray: any[], index: number) => {
        const row = Array.isArray(subArray) ? [...subArray] : [];
        if (!(row[0] && row[0].type === 'id')) {
          row.unshift({ type: 'id', value: index });
        }
        return row;
      })
      : [];

    setData(newData);
  }, [list]);

  useEffect(() => {
    if (checkbox) {
      const initialSelected = (data || []).map((row: any) => ({
        id: row[0].value,
        isChecked: false,
        data: row,
      }));
      setSelected(initialSelected);
      setSelectedAll(false);
    }
  }, [data, checkbox]);

  // notificar o componente pai quando as linhas selecionadas mudarem
  useEffect(() => {
    if (onSubmitSelectedRows) {
      const selectedRows = selected
        .filter((s) => s.isChecked)
        .map((s) => s.data);
      onSubmitSelectedRows(selectedRows);
    }
  }, [selected]);

  const HeaderComponent = !fixedHeader ? St.hederTitle : St.FixedTableHeader;
  return (
    <ContainerFlex>
      <St.Table>
        <St.headerTable>
          <tr>
            {checkbox && showSelectAll ? (
              <HeaderComponent maxChar={5} marginLeft={5}>
                <St.CheckBox
                  type="checkbox"
                  name="select-all"
                  id="select-all"
                  checked={selectedAll}
                  onChange={() => {
                    handleCheckAll();
                  }}
                />
              </HeaderComponent>
            ) : null}
            {header.map((item) => {
              if (item.hidden) return;
              return (
                <HeaderComponent
                  key={item.id}
                  maxChar={item.maxChar}
                  textAlign={item.textAlign}
                  onClick={() => item.column && handleSubmitOrder(item.column)}
                >
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {item.value}
                    {ordenationField && (
                      <div style={{ marginLeft: '10px' }}>
                        {item.column === ordenationField &&
                          orderBy === 'ASC' && (
                            <components.ArrowDown
                              style={{ transform: 'rotate(180deg)' }}
                            />
                          )}
                        {item.column === ordenationField &&
                          orderBy === 'DESC' && <components.ArrowDown />}
                      </div>
                    )}
                  </div>
                </HeaderComponent>
              );
            })}
          </tr>
        </St.headerTable>
        <St.bodyTable>
          {data.map((row) => (
            <St.bodyRow key={row[0].value} disableRowShadow={disableRowShadow}>
              {checkbox && (
                <St.bodyData maxChar={5} marginLeft={5} textAlign="center">
                  <St.CheckBox
                    type="checkbox"
                    checked={isSelected(row[0].value)}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      handleCheckbox(e, row[0].value)
                    }
                  />
                </St.bodyData>
              )}
              {row.map((item) => {
                if (item.type === 'id' || item.hidden) return null;
                if (item.type === 'icon' && item.icon) {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                      rowSpan={item.rowSpan}
                      showBottomBorder={item.showBottomBorder}
                      isLastRowOfGroup={item.isLastRowOfGroup}
                    >
                      {item.value ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            cursor: item.action && 'pointer',
                          }}
                          onClick={() =>
                            item.action(item.id, item.item, item.data, list)
                          }
                        >
                          <St.bodyDataValue maxChar={item.maxChar}>
                            {item.value}
                          </St.bodyDataValue>
                          {item.valueColor && (
                            <St.ListRowBullet color={item.valueColor} />
                          )}
                          <St.IconRow src={item.icon} alt="icon" />
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            cursor: item.action && 'pointer',
                          }}
                          onClick={() =>
                            item.action(item.id, item.item, item.data, list)
                          }
                        >
                          {item.valueColor && (
                            <St.ListRowBullet color={item.valueColor} />
                          )}
                          <St.IconRow src={item.icon} alt="icon" />
                        </div>
                      )}
                    </St.bodyData>
                  );
                }

                if (item.searchAction) {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                      rowSpan={item.rowSpan}
                      showBottomBorder={item.showBottomBorder}
                      isLastRowOfGroup={item.isLastRowOfGroup}
                    >
                      <St.ButtonContainer>
                        <ButtonSearch
                          disabled={item.searchDisabled}
                          onClick={() => item.searchAction(item.id, item.item)}
                        />
                      </St.ButtonContainer>
                    </St.bodyData>
                  );
                }

                if (item?.action && item?.status === 'PENDENTE ASSINATURA') {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                    >
                      <St.ButtonContainer>
                        <ButtonAction
                          onClick={() => item.action(item.item.id, item)}
                          icon={<components.TrashCan />}
                        />
                      </St.ButtonContainer>
                    </St.bodyData>
                  );
                }

                if (item?.status === 'DESEMBOLSADO') {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                    >
                      <St.ButtonContainer>
                        <ButtonAction
                          onClick={() =>
                            item.action(
                              item.item.idTransacaoSaqueAutorizador,
                              item,
                            )
                          }
                          icon={<MdOutlineDocumentScanner />}
                        />
                      </St.ButtonContainer>
                    </St.bodyData>
                  );
                }

                if (item.action && !item.status && !item.method) {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                    >
                      <St.ButtonContainer>
                        <ButtonAction
                          onClick={() => item.action(item.item.id, item)}
                          icon={<components.TrashCan />}
                        />
                      </St.ButtonContainer>
                    </St.bodyData>
                  );
                }

                if (
                  item?.action &&
                  item?.action2 &&
                  item.method === 'PIX' &&
                  item.type === 'FINANCIAMENTO' &&
                  !item.status &&
                  item?.item?.status === 'FATURAR'
                ) {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                      style={{ display: 'flex', gap: 5 }}
                    >
                      <St.ButtonContainer>
                        <ButtonAction
                          onClick={() => item.action(item.item.id, item)}
                          icon={<VscSend color="#E71037" />}
                        />
                      </St.ButtonContainer>
                      <St.ButtonContainer>
                        <ButtonAction
                          onClick={() => item.action2(item.item.id, item)}
                          icon={<VscTrash color="#E71037" />}
                        />
                      </St.ButtonContainer>
                    </St.bodyData>
                  );
                }

                if (
                  item.action &&
                  item.method === 'PIX' &&
                  (item.type === 'COMPRA' || item.type === 'SAQUE') &&
                  item?.item?.status === 'FATURAR'
                ) {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                    >
                      <St.ButtonContainer>
                        <ButtonAction
                          onClick={() => item.action(item.item.id, item)}
                          icon={<VscSend color="#E71037" />}
                        />
                      </St.ButtonContainer>
                    </St.bodyData>
                  );
                }

                if (
                  item.action2 &&
                  item?.item?.status === 'FATURAR' &&
                  item.type === 'FINANCIAMENTO'
                ) {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                    >
                      <St.ButtonContainer>
                        <ButtonAction
                          onClick={() => item.action2(item.item.id, item)}
                          icon={<VscTrash color="#E71037" />}
                        />
                      </St.ButtonContainer>
                    </St.bodyData>
                  );
                }

                if (item.action3) {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                    >
                      <div>
                        <Button
                          style={{ height: 40, width: '50%' }}
                          onClick={() => item.action3(item.item.id, item)}
                        >
                          <span>Desbloquear</span>
                        </Button>
                      </div>
                    </St.bodyData>
                  );
                }

                if (item.action4) {
                  return (
                    <St.bodyData
                      key={item.id}
                      maxChar={item.maxChar}
                      marginLeft={item.marginLeft}
                      textAlign={item.textAlign}
                    >
                      <div>
                        <Button
                          variant="ghost"
                          style={{ height: 40, width: '20%', border: 'none', cursor: 'pointer' }}
                          onClick={() => item.action4(item.item.id, item)}
                        >
                          <FaDownload color={"#E71037"} />
                        </Button>
                      </div>
                    </St.bodyData>
                  );
                }

                return (
                  <St.bodyData
                    key={item.id}
                    maxChar={item.maxChar}
                    marginLeft={item.marginLeft}
                    textAlign={item.textAlign}
                    rowSpan={item.rowSpan}
                    showBottomBorder={item.showBottomBorder}
                    isLastRowOfGroup={item.isLastRowOfGroup}
                    title={typeof item.value === 'string' ? item.value : ''}
                  >
                    {item.value}
                  </St.bodyData>
                );
              })}
            </St.bodyRow>
          ))}
        </St.bodyTable>
      </St.Table>
    </ContainerFlex>
  );
};

export default TableList;
